<template>
  <div class="card">
    <div class="card-content">
      <p class="title">
        <router-link :to="{name: 'article', params: { id: article.id }}">{{ article.title }}</router-link>
      </p>
      <p><date>{{ article.created_at }}</date></p>
      <p <p v-html="article.intro"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: ['article'],
  data: function () {
    return {}
  },
}
</script>

<style scoped>
  .card {
    margin-bottom: 10px;
    background-color: #ffffff;
    opacity: 0.6;
  }
  .card-content {
    color: #000000;
  }
</style>
